import { Switch } from "@mantine/core";
import { useCallback, type FC } from "react";
import { useTRPC } from "../../../trpc";
import { FormattedMessage } from "react-intl";
import { useSetUser } from "../../../hooks/user";
import { useMutation } from "@tanstack/react-query";
import type { UserDetails } from "@project/api";
import type { ChangeEvent } from "react";

interface MarketingConsentSwitchProps {
  user: UserDetails;
}

export const MarketingConsentSwitch: FC<MarketingConsentSwitchProps> = ({ user: { marketingConsent } }) => {
  const setUser = useSetUser();
  const trpc = useTRPC();

  const { mutate: changeMarketingConsent } = useMutation(trpc.changeMarketingConsent.mutationOptions());

  const handleChangeMarketing = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    changeMarketingConsent({
      marketingConsent: event.target.checked,
    }, {
      onSuccess: setUser,
    });
  }, [changeMarketingConsent]);

  return (
    <Switch
      checked={marketingConsent}
      onChange={handleChangeMarketing}
      label={(
        <FormattedMessage
          defaultMessage="Receive communication"
          id="switch.receiveCommunication"
        />
      )}
    />
  );
};
